import {DetailsField, DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Trans} from 'react-i18next'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const PlannedActionSectionEmptyState = ({isLoading}: {isLoading: boolean}) => {
    const {t} = useTranslation()

    return (
        <DetailsFieldsSection
            variant="neutral"
            title={t('projects:planned_accesses')}
            headingEndSlot={
                isLoading ? (
                    <Skeleton height={20} width={50} />
                ) : (
                    <Text palette="neutral" shade="500" size="textSm">
                        <Trans
                            i18nKey="commons:total_score_x_bolded"
                            components={{
                                b: <Text render="span" palette="neutral" shade="500" size="textSm" weight="500" />
                            }}
                            values={{count: '-'}}
                        />
                    </Text>
                )
            }
        >
            <Grid columns={2} gap={3} fullWidth>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:in_presence')}
                    </Text>
                    {isLoading ? (
                        <Skeleton height={20} width={50} />
                    ) : (
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            -
                        </Text>
                    )}
                </DetailsField>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:in_absence')}
                    </Text>
                    {isLoading ? (
                        <Skeleton height={20} width={50} />
                    ) : (
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            -
                        </Text>
                    )}
                </DetailsField>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:therapies_per_week')}
                    </Text>
                    {isLoading ? (
                        <Skeleton height={20} width={50} />
                    ) : (
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            -
                        </Text>
                    )}
                </DetailsField>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:therapies_per_month')}
                    </Text>
                    {isLoading ? (
                        <Skeleton height={20} width={50} />
                    ) : (
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            -
                        </Text>
                    )}
                </DetailsField>
            </Grid>
        </DetailsFieldsSection>
    )
}
